import { render, staticRenderFns, recyclableRender, components } from "./payment-successful.vue?vue&type=template&id=75c820a6&scoped=true&"
var renderjs
import script from "./payment-successful.vue?vue&type=script&lang=js&"
export * from "./payment-successful.vue?vue&type=script&lang=js&"
import style0 from "./payment-successful.vue?vue&type=style&index=0&id=75c820a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c820a6",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/payment-successful/payment-successful.vue"
export default component.exports